var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { getTypography, selectTheme } from '@creditas-ui/utilities';
import { styled } from '@creditas-ui/system';
var InputHint = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "efw0znt0"
} : {
  target: "efw0znt0",
  label: "InputHint"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-top: ", ";\n  color: ", ";\n  ", ";\n  margin-left: calc(\n    ", " +\n      ", "\n  );\n"])), selectTheme('checkbox.hint.marginTop'), selectTheme('checkbox.hint.color'), getTypography('bodySmRegular'), selectTheme('checkbox.shape.outter.width'), selectTheme('checkbox.label.marginLeft'));
export { InputHint };
//# sourceMappingURL=InputHint.js.map